import { Poll } from './poll';

export class FilteredPolls {
    constructor(
        public totalItems?: number,
        public currentPage?: number,
        public polls?: Poll[],
    ) { }

    clone() {
        return new FilteredPolls(
            this.totalItems,
            this.currentPage,
            this.polls,
        );
    }
}
